<template>
  <el-dialog
    title="批量改价"
    :visible.sync="visible"
    width="400px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="toggle(false)"
    append-to-body
    center
  >
    <el-form
      class="staff-from"
      v-loading="loading"
      element-loading-text="加载中…"
      ref="elFormDom"
      label-position="right"
      label-width="100px"
      :model="form.data"
      :rules="form.rules"
      :size="subUnitSize"
    >
      <el-form-item label="供应商" prop="supplier_id">
        <el-select
          v-model.trim="form.data.supplier_id"
          filterable
          clearable
          placeholder="请输入"
        >
          <el-option
            v-for="item in supplierArr"
            :label="item.name"
            :value="item.id"
            :key="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="交货日期" prop="delivery_date">
        <el-date-picker
          v-model="form.data.delivery_date"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          class="selDaterangeWidth"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="商品名称" prop="good_name">
        <el-select
          v-model="form.data.good_name"
          filterable
          remote
          placeholder="请输入关键词"
          :remote-method="remoteMethod"
          :loading="selLoading"
          size="small"
          value-key="id"
        >
          <el-option
            v-for="item in goodArr"
            :label="`${item.good_name} ${!!item.unit_name ? item.unit_name :''} ${!!item.name ? `(${item.name})` : ''}`"
            :value="item"
            :key="item.id"
          >
            <div class="flex" style="justify-content: space-between">
              <div>
                <span style="float: left">{{ item.good_name }}</span>
              </div>
              <span style="color: #8492a6; font-size: 13px">
                {{item.unit_name}}/
                {{
                item.name
              }}</span>
            </div>
            <div style="color: #999; margin-top: -5px" v-if="!!item.norm_name">
              标名：{{ item.norm_name }}
            </div>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="修改单价" prop="amount">
        <el-input
          v-money
          v-model="form.data.amount"
          clearable
          placeholder="请输入"
        >
          <span slot="suffix">元</span>
        </el-input>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-row type="flex" justify="center">
        <el-button
          type="primary"
          :loading="form.loading"
          :disabled="form.loading"
          @click="confirm"
          >确定</el-button
        >
      </el-row>
    </template>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      supplierArr: [],
      subUnitSize: this.$store.state.subUnitSize, // 获取组件 size属性
      visible: false,
      loading: false,
      goodArr: [],
      selLoading: false,
      form: {
        loading: false,
        data: {
          supplier_id:'',
          delivery_date:[],
          good_name: "",
          amount: "",
        },
        rules: {
          supplier_id: [{ required: true, message: "必填", trigger: "change" }],
          delivery_date: [{ required: true, message: "必填", trigger: "change" }],
          good_name: [{ required: true, message: "必填", trigger: "change" }],
          amount: [{ required: true, message: "必填", trigger: "change" }],
        },
      },
    };
  },
  mounted() {
    this.getSupplierSelAll();
  },
  methods: {
    remoteMethod(query) {
      if (query !== "") {
        let _params = {
          page: 1,
          count: 1000,
          status: 1,
          good_name: query,
          // merchant_id: this.form.data.merchant_id,
          // address_id: this.form.data.address_id,
        };
        this.selLoading = true;
        this.$http
          .get("/admin/goods/specList", { params: _params })
          .then((res) => {
            if (res.code === 1) {
              this.goodArr = res.data.list;
            }
          })
          .finally(() => {
            this.selLoading = false;
          });
      } else {
        this.goodArr = [];
      }
    },
    getSupplierSelAll() {
      this.$http
        .get("/admin/supplier/allList", {
          params: { is_all: 1, page: 1, count: 10000 },
        })
        .then((res) => {
          if (res.code == 1) {
            this.supplierArr = res.data.list;
          }
        });
    },
    getDetail(row) {},
    reset(done) {
      this.$refs.elFormDom.resetFields();
      this.form.data = {
        supplier_id:'',
        delivery_date:[],
        good_name: "",
        amount: "",
      };
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    // 提交
    confirm() {
      this.$refs.elFormDom.validate((valid) => {
        if(valid) {
          this.form.loading = true;
          const [start = '',end = ''] = this.form.data.delivery_date;
          let params = {
            spec_id: this.form.data.good_name.id,
            amount: this.form.data.amount,
            start,
            end,
            supplier_id: this.form.data.supplier_id
          };
          this.$http.post('/admin/purchase_order/patchPrice', params).then(res => {
            if (res.code === 1) {
              this.$message({
                type: 'success',
                message: '操作成功'
              });
              this.toggle(false);
              this.$emit('refresh');
            }
          }).finally(() => {
            this.form.loading = false;
          });
        }
      });
    },
  },
};
</script>
